import { caseManagementApi } from '../caseManagementApi';
import { WorklistView } from '../types/worklistTypes';
import { WorklistEndpointRequest } from '../requests/worklistRequest';

const worklistEndpoints = caseManagementApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get worklist for case management
    // GET /CaseManWorklist?type=<type>&center=<center>&company=<company>
    getWorklist: builder.query<WorklistView[], WorklistEndpointRequest>({
      query: ({ type, center, company }) => ({
        url: 'CaseManWorklist',
        params: { type, center, company },
      }),
      providesTags: (result, error, { type, center, company }) => [
        { type: 'Worklist', id: `${type}-${center}-${company}` },
        'Worklist',
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWorklistQuery } = worklistEndpoints;
